var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 1.36364H0.681818C0.500989 1.36364 0.327566 1.2918 0.1997 1.16394C0.0718342 1.03607 0 0.862648 0 0.681818C0 0.500989 0.0718342 0.327566 0.1997 0.1997C0.327566 0.0718343 0.500989 0 0.681818 0H21.1364C21.3172 0 21.4906 0.0718343 21.6185 0.1997C21.7463 0.327566 21.8182 0.500989 21.8182 0.681818C21.8182 0.862648 21.7463 1.03607 21.6185 1.16394C21.4906 1.2918 21.3172 1.36364 21.1364 1.36364Z",
    fill: "#1ea149"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 8.18181H0.681818C0.500989 8.18181 0.327566 8.10998 0.1997 7.98211C0.0718342 7.85425 0 7.68082 0 7.49999C0 7.31916 0.0718342 7.14574 0.1997 7.01788C0.327566 6.89001 0.500989 6.81818 0.681818 6.81818H21.1364C21.3172 6.81818 21.4906 6.89001 21.6185 7.01788C21.7463 7.14574 21.8182 7.31916 21.8182 7.49999C21.8182 7.68082 21.7463 7.85425 21.6185 7.98211C21.4906 8.10998 21.3172 8.18181 21.1364 8.18181Z",
    fill: "#1ea149"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 15H0.681818C0.500989 15 0.327566 14.9282 0.1997 14.8003C0.0718342 14.6724 0 14.499 0 14.3182C0 14.1373 0.0718342 13.9639 0.1997 13.8361C0.327566 13.7082 0.500989 13.6364 0.681818 13.6364H21.1364C21.3172 13.6364 21.4906 13.7082 21.6185 13.8361C21.7463 13.9639 21.8182 14.1373 21.8182 14.3182C21.8182 14.499 21.7463 14.6724 21.6185 14.8003C21.4906 14.9282 21.3172 15 21.1364 15Z",
    fill: "#1ea149"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.551f9b172a419380a0e3b648103ae986.svg";
export { ForwardRef as ReactComponent };